module.exports = __webpack_public_path__ + "img/logo_transparent-no-text.1f2e5ada.png";